import React, { useState } from 'react';

import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import { CustomDropdown } from 'ui/custom-controls';

import { ObjectType } from '../../types/interfaces';
import { AssetForEdit } from '../../types/interfaces/AssetForEdit';
import { AssetTriggerType } from '../../types/interfaces/triggers';

interface MainTabContentProps {
  state?: boolean;
  register: UseFormRegister<AssetForEdit>;
  setValue: UseFormSetValue<AssetForEdit>;
  watch: (field: string) => any;
  errors: FieldErrors;
  handleInputChange: (currentTrigger: AssetTriggerType) => void;
  selectedAssetType: ObjectType | null;
  assetTypesFilterOptions: ObjectType[];
  handleAssetTypeChange: (newObjectType: ObjectType | null) => void;
  withoutDialog?: boolean;
  isMobile?: boolean
}

const MainTabContent = ({
  state,
  register,
  setValue,
  watch,
  errors,
  handleInputChange,
  selectedAssetType,
  assetTypesFilterOptions,
  handleAssetTypeChange,
  withoutDialog,
  isMobile = false
}: MainTabContentProps) => {
  const [, forceUpdate] = useState<number>(0);
  const required = !withoutDialog ? <span className="required">*</span> : null;

  return (
    <div className={'flex flex-column md:flex-row gap-3 pb-0 '}       style={isMobile ? { 
      maxHeight: '40vh',
      overflow: 'auto',
      paddingRight: '4px' 
    } : {}}
    >
      <div className="asset-card__column w-full">
        {!withoutDialog && (
          <div className="flex gap-3 justify-content-between card-row--bottom-margin ">
            <label htmlFor="state">Активен: </label>
            <div className="asset-card--checkbox">
              <Checkbox
                {...register('state')}
                checked={state ?? false}
                onChange={(e) => setValue('state', e.checked || false)}
              />
            </div>
          </div>
        )}

        <div className="flex flex-column">
          <div className="flex justify-content-between align-items-center gap-3">
            <label className="task-card__label" htmlFor="name">
              Название объекта{required}:
            </label>
            <InputText
              className="user-card__input asset-card--input"
              {...register('name', {
                onChange: () => handleInputChange('name')
              })}
              readOnly={withoutDialog || undefined}
            />
          </div>
          <p
            className={`card-errors ${
              errors.name ? 'text-red-500' : 'text-transparent'
            } `}
          >
            {errors.name ? errors.name.message : ' '}
          </p>
        </div>

        <div className="flex flex-column">
          <div className="flex justify-content-between align-items-center gap-3">
            <label className="task-card__label" htmlFor="type">
              Тип объекта{required}:
            </label>
            {!withoutDialog ? (
              <div className="flex flex-row asset-card--dropdown">
                <CustomDropdown
                  passedClassName="w-full"
                  assetOptions={assetTypesFilterOptions}
                  selectedAsset={selectedAssetType}
                  onSelectionChange={(selected) => {
                    handleAssetTypeChange(selected as ObjectType | null);
                    forceUpdate((prev) => prev + 1);
                  }}
                  placeholder="Тип объекта"
                  disabled={!!withoutDialog}
                  showDeletedWarning
                  deletedWarningTooltip="Тип объекта удалён в справочнике"
                  showClearOnHover
                />
              </div>
            ) : (
              <InputText
                className="user-card__input asset-card--input"
                {...register('type.label')}
                defaultValue={selectedAssetType?.label || ''} // Set the initial value from selectedAssetType
                readOnly
              />
            )}
          </div>
          <p
            className={`card-errors ${
              errors.type ? 'text-red-500' : 'text-transparent'
            } `}
          >
            {errors.type ? errors.type.label.message : ' '}
          </p>
        </div>

        <div className="flex flex-column">
          <div className="flex justify-content-between align-items-center gap-3">
            <label className="task-card__label" htmlFor="externalId">
              Внешний №:
            </label>
            <InputText
              className="user-card__input asset-card--input"
              {...register('externalId', {
                onChange: () => handleInputChange('externalId')
              })}
              readOnly={withoutDialog || undefined}
            />
          </div>
          <p
            className={`card-errors ${
              errors.externalId ? 'text-red-500' : 'text-transparent'
            } `}
          >
            {errors.externalId ? errors.externalId.message : ' '}
          </p>
        </div>

        {withoutDialog && (
          <div className="flex flex-column">
            <div className="flex justify-content-between align-items-center gap-3">
              <label className="task-card__label" htmlFor="address">
                Адрес:
              </label>
              <InputText
                className="user-card__input asset-card--input"
                value={
                  watch('cityFias')
                    ? [
                      watch('cityFias')?.fullName,
                      watch('streetFias')?.name,
                      watch('houseFias')?.name
                    ]
                      .filter(Boolean)
                      .join(', ')
                    : [
                      watch('customCity'),
                      watch('customStreet'),
                      watch('customHouse')
                    ]
                      .filter((item) => item?.trim())
                      .join(', ')
                }
                readOnly
              />
            </div>
            <p
              className={`card-errors ${
                errors.address ? 'text-red-500' : 'text-transparent'
              } `}
            >
              {errors.address ? errors.address.message : ' '}
            </p>
          </div>
        )}

        <div className="flex flex-column">
          <div className="flex justify-content-between align-items-center gap-3">
            <label className="task-card__label" htmlFor="description">
              Описание:
            </label>
            <InputText
              className="user-card__input asset-card--input"
              {...register('description', {
                onChange: () => handleInputChange('description')
              })}
              readOnly={withoutDialog || undefined}
            />
          </div>
          <p
            className={`card-errors ${
              errors.description ? 'text-red-500' : 'text-transparent'
            } `}
          >
            {errors.description ? errors.description.message : ' '}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MainTabContent;
